import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LoaderModule } from "@portal-core/general/components/loader/loader.module";
import { CollabFileTextEditorStatusBarModule } from "@portal-core/text-editor/components/collab-file-text-editor-status-bar/collab-file-text-editor-status-bar.module";
import { FilePropertiesModule } from "../file-properties/file-properties.module";
import { TopicPropertiesModule } from "../topic-properties/topic-properties.module";
import { FlarePropertiesEditorComponent } from './flare-properties-editor.component';


@NgModule({
  declarations: [
    FlarePropertiesEditorComponent
  ],
  imports: [
    CommonModule,
    LoaderModule,
    TopicPropertiesModule,
    FilePropertiesModule,
    CollabFileTextEditorStatusBarModule
  ],
  exports: [
    FlarePropertiesEditorComponent
  ]
})
export class FlarePropertiesEditorModule { }
